'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SimpleUGCDisplay = require('./components/SimpleUGCDisplay');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SimpleUGCDisplay).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/shared/ugc-editors/lib/components/simple-ugc-display/index.js
// module id = 373
// module chunks = 4